import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'PARAM_ENT',
  title: 'Come posso modificare le impostazioni della mia azienda?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Per accedere alle impostazioni aziendali, fare clic sulla scheda «Parametri»:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_PARAM_ENT/IT_PARAM_ENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Poi si arriva alla pagina delle impostazioni della vostra azienda che è possibile visualizzare. Per modificare queste impostazioni, devi richiederle al Servizio Clienti cliccando su «Contatta il Servizio Clienti» ed effettuando la tua richiesta di modifica:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_PARAM_ENT/IT_PARAM_ENT_2.png`
  }]
};
